export enum EnvironmentName {
	Local,
	Dev,
	Qa,
	Prod
}
